<template>
  <div id="app">
    <Header/>

    <transition name="component-fade" mode="out-in">
      <router-view class="view"></router-view>
    </transition>

    <Footer/>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import "@/assets/css/normalize.css";

export default {
  name: "App",
  metaInfo: {
    title: "A blog about coding",
    titleTemplate: "%s ← Mark Bloomfield's Blog"
  },
  components: {
    Header,
    Footer
  }
};
</script>


<style>
@import url("//fonts.googleapis.com/css?family=Nunito:200,600,700");

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

html {
  font-size: 18px;
}

@media (min-width: 992px) {
  html {
    font-size: 22px;
  }
}

body {
  padding-top: 50px;
}

@media (max-width: 992px) {
  .a-post {
    margin-bottom: 100px;
  }
}

html,
body {
  height: 100%;
}

* {
  box-sizing: border-box;
}

#app {
  font-family: "Nunito", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 200;
  line-height: 1.6;
  padding: 5%;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Nunito";
  font-weight: 700;
  margin: 0 0 40px;
}

.post-title {
  margin: 0 0 60px;
}

.post-title.summary-title {
  margin-bottom: 20px;
}

.single-full p,
.single-full ul,
.single-full ol,
.single-full pre,
.single-full figure {
  margin: 0 0 40px !important;
}

.single-full a {
  color: #7ea8be;
}

.single-full figure img {
  max-width: 100%;
  height: auto;
}

.single-full figcaption {
  text-align: right;
  color: rgba(0, 0, 0, 0.5);
}

.single-full code {
  background: #2d2d2d;
  color: #ccc;
  padding: 0 4px 0;
  border-radius: 2px;
  display: inline-block;
}

@media (min-width: 850px) {
  .single-full pre {
    margin-left: calc(-100vw / 2 + 850px / 2) !important;
    margin-right: calc(-100vw / 2 + 850px / 2) !important;
    padding-top: 40px !important;
    padding-bottom: 40px !important;
  }
  .single-full pre code {
    display: block;
    max-width: 850px !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }
}
</style>
